module.exports = __webpack_public_path__ + "static/media/ticker_icon_customer.f21be23a.svg";